import { useEffect } from "react";

const useScrollToTopPage = ({ deps } = {}) => {
    const dependencies = Array.isArray(deps) ? deps : [];
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [...dependencies])
}

export default useScrollToTopPage